var React = require('react');

function Bell (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 22c0 1.1-1.35 2-3 2s-3-.9-3-2m14-2.167V21H1v-1.167L3.444 17.5v-7c0-3.615 2.482-6.802 6.112-7.83v-.337C9.556 1.05 10.656 0 12 0c1.344 0 2.444 1.05 2.444 2.333v.337c3.63 1.028 6.112 4.215 6.112 7.83v7L23 19.833","fillRule":"evenodd"}));
}

Bell.defaultProps = {"width":"24","height":"24"};

module.exports = Bell;

Bell.default = Bell;
